import { useState, useEffect, useCallback } from "react";

import { getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";

export function useServerGridSelectedResultState(
  gridData,
  isSelectable,
  dataItemKey
) {
  const [gridResultState, setGridResultState] = useState(gridData);

  const [selectedMainGridState, setSelectedMainGridState] = useState([]);

  const SELECTED_FIELD = "SelectedId";
  //if not selectable, set the grid result state to same as gridData

  useEffect(() => {
    if (!gridData) {
      return;
    }

    let allSelectedKeys = GetSelectedGridDataKeys();

    let processedData = gridData.map((item) => ({
      ...item,
      [SELECTED_FIELD]:
        isSelectable && allSelectedKeys.includes(item[dataItemKey].toString()),
    }));

    setGridResultState(processedData);
  }, [gridData, selectedMainGridState]);

  const onSelectionChange = useCallback(
    (event) => {
      if (event.startColIndex == 0) {
        const newSelectedState = getSelectedState({
          event,
          selectedState: selectedMainGridState,
          dataItemKey: dataItemKey,
        });

        setSelectedMainGridState(newSelectedState);
      }
    },
    [selectedMainGridState]
  );

  const GetSelectedGridDataKeys = () => {
    var selectableKeys = Object.keys(selectedMainGridState);

    var selectedKeys = selectableKeys.filter(function (key) {
      return selectedMainGridState[key] === true;
    });

    return selectedKeys;
  };

  const UnSelectAll = () => {
    //reset the selected state to nothing selected
    setSelectedMainGridState({});
  };

  const SelectAll = () => {
    // make sure evbery record in grid is selected
    const idGetter = getter(dataItemKey);

    let newSelectedState = { ...selectedMainGridState };

    if (gridData.length > 0) {
      gridData.forEach((item) => {
        //add the item if not already in the selected state
        if (!newSelectedState[idGetter(item)]) {
          newSelectedState[idGetter(item)] = true;
        }
      });
    }

    setSelectedMainGridState(newSelectedState);
  };

  return {
    gridResultState,
    onSelectionChange,
    SelectAll,
    UnSelectAll,
    GetSelectedGridDataKeys,
  };
}
